import {
  userListSchema,
  userSchema,
  type User,
  type UserCreateInput,
  type UserList,
  type UserUpdateInput,
} from '@plane/shared';

import { apiRequest } from '@/services/http-client';

/**
 * Chamadas do CRUD de usuários.
 *
 * O schema em cada chamada não é enfeite: sem ele, uma mudança no contrato da
 * API viraria `undefined` no meio de um componente em vez de erro claro.
 *
 * Não há exclusão: a API não expõe DELETE. Desativar é o caminho, e é
 * reversível — ver `users.routes.ts`.
 */

export function fetchUsers(page: number, perPage: number): Promise<UserList> {
  return apiRequest(`/api/v1/users?page=${page}&perPage=${perPage}`, userListSchema);
}

export function createUser(input: UserCreateInput): Promise<User> {
  return apiRequest('/api/v1/users', userSchema, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function updateUser(id: string, input: UserUpdateInput): Promise<User> {
  return apiRequest(`/api/v1/users/${id}`, userSchema, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}
